module.exports = __webpack_public_path__ + "static/media/KaomojiMixer.1602984e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/KaomojiMixer.png
// module id = 347
// module chunks = 0